import React from "react";
import Icons from "components/icons";
import { Localize } from "components/service";
import {
    getStaffAuditReason,
    getStaffAuditReasonDetail,
    getStaffAuditResult,
} from "../helpers/staff-audit-log-presentation-helper";


const reasonIcons = {
    within_radius: Icons.StaffLocation,
    outside_radius: Icons.StaffLocationFailed,
    duplicate_scan: Icons.StaffQrCode,
    location_permission_denied: Icons.StaffLocationFailed,
    camera_permission_denied: Icons.StaffCameraAccess,
    outside_schedule: Icons.StaffClock,
    location_unavailable: Icons.StaffLocationFailed,
    no_open_session: Icons.StaffQrCode,
    same_device: Icons.StaffSameDevice,
    invalid_qr: Icons.StaffInvalidQr,
    manual_close: Icons.StaffCheckOut,
};

const StaffAuditReasonField = ({ auditLog }) => {
    const reason = getStaffAuditReason(auditLog?.reason);
    const reasonDetail = getStaffAuditReasonDetail(auditLog);
    const result = getStaffAuditResult(auditLog?.status);
    const ReasonIcon = reasonIcons[ reason ];

    return (
        <span className={ `staff-audit-reason staff-audit-reason--${ reason } staff-audit-reason--result-${ result }` }>
            { ReasonIcon &&
                <span className="d-flex align-items-center justify-content-center staff-audit-reason__icon" aria-hidden="true">
                    <ReasonIcon />
                </span>
            }
            <span className="staff-audit-reason__text">
                { reason === "manual_close" && !reasonDetail ?
                    <Localize>STAFF_MANAGEMENT.ManualCheckout_UnknownActor</Localize> :
                    <Localize worker={ reasonDetail || "—" } name={ reasonDetail }>
                        { `STAFF_MANAGEMENT.AuditReason_${ reason }` }
                    </Localize>
                }
            </span>
        </span>
    );
};

export default StaffAuditReasonField;
